import { render, staticRenderFns } from "./UserServices.vue?vue&type=template&id=9f862506&scoped=true&"
import script from "./UserServices.vue?vue&type=script&lang=js&"
export * from "./UserServices.vue?vue&type=script&lang=js&"
import style0 from "./UserServices.vue?vue&type=style&index=0&id=9f862506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f862506",
  null
  
)

export default component.exports